import { createElement } from 'react';
import { render } from 'react-dom';
import { fetchSubmitOrderTranslations } from '../react/services/TranslationService';

export default class SubmitOrder {
    constructor() {
        this.container = document.querySelector('.js-submit-order');

        if (this.container) {
            this.start();
        }
    }

    start() {
        const isDealer = this.container.getAttribute('data-dealer'),
            fName = this.container.getAttribute('data-fName'),
            lName = this.container.getAttribute('data-lName'),
            email = this.container.getAttribute('data-email'),
            phone = this.container.getAttribute('data-phone'),
            address = this.container.getAttribute('data-address'),
            city = this.container.getAttribute('data-city'),
            stateCode = this.container.getAttribute('data-state'),
            countryCode = this.container.getAttribute('data-country'),
            postal = this.container.getAttribute('data-postal');

        Promise.all([
            import('../react/components/submit-order.jsx'),
            fetchSubmitOrderTranslations()
        ])
            .then(([SubmitOrder, translations]) => {
                render(createElement(SubmitOrder.default, {isDealer, fName, lName, email, phone, address, city, stateCode, countryCode, postal, allowStatesDropdown: true, allowCountriesDropdown: true, translations}),  this.container);
            })
            .catch(error => {
                console.log(error);
            });
    }
}